import script from "./partnerAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./partnerAdd.vue?vue&type=script&setup=true&lang=js"

import "./partnerAdd.vue?vue&type=style&index=0&id=3c70e704&lang=scss&scoped=true"
import "./partnerAdd.vue?vue&type=style&index=1&id=3c70e704&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c70e704"]])

export default __exports__